import React from 'react';

function CustomTable({ recentSurveys, setPlotSurveyOnMap, plotSurveyOnMap }) {
  const casteMapping = [
    "अन्य / Others",
    "GENERAL",
    "OBC",
    "SC",
    "ST",
    "मुसलमान / Muslim",
    "ईसाई / Christanity",
    "सिख / Sikh",
    "स्वर्ण हिन्दू",
    "कोई मत नही / कह नहीं सकते"
  ];
  const tableHeaderStyle = {
    position: 'sticky',
    top: 0,
  };
  const handlePlotSurvey = () => {
    const surveysToPlot = [];
    let i =0;
    recentSurveys.map((survey)=>{
      surveysToPlot.push({ id:i++, geocode : {lat:survey.latitude,lng:survey.longitude}})
    })
    setPlotSurveyOnMap(surveysToPlot)

  }
  return (
    <>
      {recentSurveys.length > 0 ? (
        <div>
          <div className="container" style={{ height: '400px', overflowY: 'auto', marginTop: '27px' }}>
            <table className="rwd-table">
              <thead style={tableHeaderStyle}>
                <tr style={{ color: '#fff' }}>
                  <th>NAME</th>
                  <th>PHONE</th>
                  <th>AGE</th>
                  <th>CASTE</th>
                </tr>
              </thead>
              <tbody>
                {recentSurveys.map((survey, index) => (
                  <tr key={index}>
                    <td>{survey.name}</td>
                    <td>{survey.phone}</td>
                    <td>{survey.age}</td>
                    <td>{casteMapping[survey.cast_id]}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <button onClick={handlePlotSurvey} className="re_custom_btn show_on_map" >Show Surveys On Map</button>
        </div>
      ) : null}
    </>
  );
}

export default CustomTable;
